










































import Reflect from "reflect-metadata";
import { Component, Vue, PropSync } from "vue-property-decorator";
import { User } from "@/models/User";
import { validateDni, dniFilter } from "@/filters/DniFilter";

@Component({
  filters: {
    dni: dniFilter
  }
})
export default class UserInfo extends Vue {
  @PropSync("user") userInfo!: Partial<User>;

  /**
   * Parses a string into a proper R.U.T.
   */
  filterDni(value: string) {
    this.userInfo.dni = dniFilter(value);
  }
  /**
   * Validation rules for inputs
   */
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    max: (value: string) =>
      (value && value.length <= 50) || "Máximo 50 caracteres",
    dni: (value: string) =>
      !value || validateDni(value) || "El RUT no es válido"
  };
}
